import { showUsernameError } from "./showUsernameError";
import {hideUsernameError} from "./hideUsernameError";

const MIN_NICKNAME_LENGTH = 5;

export interface UsernameCheckResponse {
    result: number;
    suggestion: string;
    messages: {
        username: string[];
    }
}

export const checkUsername = (e: Event) => {
	const usernameEl = e.currentTarget as HTMLInputElement,
		  username = usernameEl.value;
	if(username.length > MIN_NICKNAME_LENGTH) {
		fetch(`/vxpay/username/?username=${username}`)
			.then(response => response.json())
			.then((data: UsernameCheckResponse) => {
				if((data?.result === -2)) {
					showUsernameError(data.messages.username[0], data.suggestion);
				}else {
					hideUsernameError()
				}

			})
	}else{
		showUsernameError('Username too short', '')
	}
}
